module.exports = __webpack_public_path__ + "static/education_lesson@2x-4c539dd06a173a38f5b9a78cb9e2b5c7.png";